import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, Brain, Leaf, Heart, Sparkles, Shield, ChevronDown, ChevronUp } from 'lucide-react';
const synergies = [{
  id: 1,
  section: 'DOLOR E INFLAMACIÓN',
  sectionColor: 'bg-[#B91C1C]',
  icon: Flame,
  iconColor: 'text-[#B91C1C]',
  bg: 'bg-[#FEF2F2]',
  border: 'border-[#FECACA]',
  name: '🔥 "FUEGO APAGADO"',
  for: 'Artritis, Articulaciones, Dolor Crónico',
  time: '72 horas',
  impact: 10,
  teaser: 'Cúrcuma + Pimienta Negra + Aceite de Coco. La pimienta aumenta la absorción de curcumina en un 2,000%. Igual que el ibuprofeno — sin dañar el estómago.',
  science: 'Frontiers in Pharmacology 2022'
}, {
  id: 2,
  section: 'DOLOR E INFLAMACIÓN',
  sectionColor: 'bg-[#B91C1C]',
  icon: Flame,
  iconColor: 'text-[#B91C1C]',
  bg: 'bg-[#FEF2F2]',
  border: 'border-[#FECACA]',
  name: '💪 "ARTICULACIÓN DE ACERO"',
  for: 'Dolor Agudo, Rodillas, Manos, Columna',
  time: '20 minutos',
  impact: 9,
  teaser: 'Árnica Montana + Eucalipto + Cera de Abeja. Aplicación directa que penetra el tejido inflamado en minutos.',
  science: 'Phytomedicine Journal 2021'
}, {
  id: 3,
  section: 'NEUROLOGÍA Y MEMORIA',
  sectionColor: 'bg-[#7C3AED]',
  icon: Brain,
  iconColor: 'text-[#7C3AED]',
  bg: 'bg-[#F5F3FF]',
  border: 'border-[#DDD6FE]',
  name: '🧠 "CEREBRO DE CRISTAL"',
  for: 'Niebla Mental, Concentración, Memoria',
  time: '45 minutos',
  impact: 10,
  teaser: 'Melena de León + Gotu Kola + Romero. Estimula el Factor de Crecimiento Nervioso. Literalmente regenera neuronas.',
  science: 'Journal of Ethnopharmacology 2020'
}, {
  id: 4,
  section: 'NEUROLOGÍA Y MEMORIA',
  sectionColor: 'bg-[#7C3AED]',
  icon: Brain,
  iconColor: 'text-[#7C3AED]',
  bg: 'bg-[#F5F3FF]',
  border: 'border-[#DDD6FE]',
  name: '🌙 "ARQUITECTO DEL SUEÑO"',
  for: 'Insomnio, Despertares Nocturnos, Sueño No Reparador',
  time: 'Primera noche',
  impact: 9,
  teaser: 'Valeriana + Pasiflora + Nuez Moscada. Activan el receptor GABA-A — el mismo que los somníferos, pero sin dependencia.',
  science: 'PubMed Central 2019'
}, {
  id: 5,
  section: 'SISTEMA DIGESTIVO',
  sectionColor: 'bg-[#166534]',
  icon: Leaf,
  iconColor: 'text-[#166534]',
  bg: 'bg-[#F0FDF4]',
  border: 'border-[#BBF7D0]',
  name: '🛡️ "INTESTINO BLINDADO"',
  for: 'Intestino Permeable, Colon Irritable, Inflamación',
  time: '7 días',
  impact: 10,
  teaser: 'Raíz de Malvavisco + Aloe Vera + Caldo de Hueso. Sella físicamente las micro-perforaciones intestinales con mucílago natural.',
  science: 'Gut Microbiota Journal 2021'
}, {
  id: 6,
  section: 'SISTEMA DIGESTIVO',
  sectionColor: 'bg-[#166534]',
  icon: Leaf,
  iconColor: 'text-[#166534]',
  bg: 'bg-[#F0FDF4]',
  border: 'border-[#BBF7D0]',
  name: '⚡ "DIGESTIVO MAESTRO"',
  for: 'Hinchazón, Gases, Pesadez Post-Comida',
  time: '15-20 minutos',
  impact: 8,
  teaser: 'Hinojo + Anís + Menta + Jengibre. Triple acción antiespasmódica que relaja el músculo liso intestinal.',
  science: 'Phytotherapy Research 2018'
}, {
  id: 7,
  section: 'SISTEMA CARDIOVASCULAR',
  sectionColor: 'bg-[#1D4ED8]',
  icon: Heart,
  iconColor: 'text-[#1D4ED8]',
  bg: 'bg-[#EFF6FF]',
  border: 'border-[#BFDBFE]',
  name: '❤️ "CORAZÓN DE ATLETA"',
  for: 'Presión Alta, Arterias Rígidas, Circulación',
  time: '30 días',
  impact: 10,
  teaser: 'Ajo Negro Fermentado + Remolacha + Espino Blanco. Dispara la producción de Óxido Nítrico, ensanchando arterias en minutos.',
  science: 'American Journal of Hypertension'
}, {
  id: 8,
  section: 'SISTEMA HORMONAL',
  sectionColor: 'bg-[#9D174D]',
  icon: Sparkles,
  iconColor: 'text-[#9D174D]',
  bg: 'bg-[#FDF2F8]',
  border: 'border-[#FBCFE8]',
  name: '✨ "ARMONÍA HORMONAL"',
  for: 'Menopausia, Sofocos, Cambios de Humor',
  time: '14 días',
  impact: 10,
  teaser: 'Maca Gelatinizada + Aceite de Onagra + Salvia Oficinal. Regula la producción hormonal sin introducir hormonas externas.',
  science: 'Menopause Journal 2020'
}, {
  id: 9,
  section: 'INMUNIDAD Y DEFENSA',
  sectionColor: 'bg-[#C17817]',
  icon: Shield,
  iconColor: 'text-[#C17817]',
  bg: 'bg-[#FFFBEB]',
  border: 'border-[#FDE68A]',
  name: '🛡️ "ESCUDO INMUNE ABSOLUTO"',
  for: 'Inmunidad Baja, Infecciones Recurrentes',
  time: '48 horas en crisis',
  impact: 10,
  teaser: 'Equinácea + Saúco + Vitamina C de Escaramujo + Astragalus. La Vitamina C natural es 400% más activa que la sintética.',
  science: 'PubMed Central 2023'
}];
function ImpactBar({
  score
}: {
  score: number;
}) {
  return <div className="flex items-center gap-2" data-id="element-469">
      <div className="flex gap-0.5" data-id="element-470">
        {Array.from({
        length: 10
      }).map((_, i) => <div key={i} className={`w-2 h-3 rounded-sm ${i < score ? 'bg-[#C17817]' : 'bg-[#E8DFD0]'}`} data-id="element-471" />)}
      </div>
      <span className="text-xs font-bold text-[#C17817]" data-id="element-472">{score}/10</span>
    </div>;
}
export function WeeklyBreakdown() {
  const [expanded, setExpanded] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-[#F0F4EC] border-t border-[#E8DFD0]" data-id="element-473">
      <div className="max-w-[800px] mx-auto" data-id="element-474">
        <div className="text-center mb-12" data-id="element-475">
          <p className="text-xs font-bold uppercase tracking-widest text-[#C17817] mb-2" data-id="element-476">
            Lo Que Está Dentro
          </p>
          <h2 className="text-3xl font-serif font-bold text-[#2C1810] mb-4" data-id="element-477">
            Las 9 Sinergias Maestras
          </h2>
          <p className="text-[#5C4A3A] max-w-xl mx-auto" data-id="element-478">
            Cada protocolo está documentado con ingredientes exactos, dosis
            precisas, método de preparación y respaldo científico peer-reviewed.
          </p>
        </div>

        <div className="space-y-3" data-id="element-479">
          {synergies.map((s, i) => <motion.div key={s.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className={`bg-white rounded-xl border ${s.border} shadow-sm overflow-hidden`} data-id="element-480">
              <button className="w-full text-left p-4 flex items-start gap-4" onClick={() => setExpanded(expanded === s.id ? null : s.id)} data-id="element-481">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${s.bg} border ${s.border}`} data-id="element-482">
                  <span className="text-sm font-bold text-[#2C1810]" data-id="element-483">
                    {s.id}
                  </span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-484">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-485">
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full text-white ${s.sectionColor}`} data-id="element-486">
                      {s.section}
                    </span>
                  </div>
                  <h3 className="font-bold text-[#2C1810] text-base leading-tight" data-id="element-487">
                    {s.name}
                  </h3>
                  <p className={`text-xs font-medium mt-1 ${s.iconColor}`} data-id="element-488">
                    {s.for}
                  </p>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-2" data-id="element-489">
                  <div className="text-right" data-id="element-490">
                    <p className="text-[10px] text-[#8B7355] uppercase tracking-wider" data-id="element-491">
                      Respuesta
                    </p>
                    <p className="text-xs font-bold text-[#2C1810]" data-id="element-492">{s.time}</p>
                  </div>
                  {expanded === s.id ? <ChevronUp className="w-4 h-4 text-[#8B7355]" data-id="element-493" /> : <ChevronDown className="w-4 h-4 text-[#8B7355]" data-id="element-494" />}
                </div>
              </button>

              {expanded === s.id && <div className={`px-4 pb-4 ${s.bg} border-t ${s.border}`} data-id="element-495">
                  <div className="pt-3 space-y-3" data-id="element-496">
                    <p className="text-[#2C1810] text-sm leading-relaxed" data-id="element-497">
                      {s.teaser}
                    </p>
                    <div className="flex items-center justify-between" data-id="element-498">
                      <div data-id="element-499">
                        <p className="text-[10px] text-[#8B7355] uppercase tracking-wider mb-1" data-id="element-500">
                          Nivel de Impacto
                        </p>
                        <ImpactBar score={s.impact} data-id="element-501" />
                      </div>
                      <div className="text-right" data-id="element-502">
                        <p className="text-[10px] text-[#8B7355] uppercase tracking-wider mb-1" data-id="element-503">
                          Respaldo Científico
                        </p>
                        <p className="text-xs font-medium text-[#2D5A3D] italic" data-id="element-504">
                          {s.science}
                        </p>
                      </div>
                    </div>
                    <a href="#comprar" className={`block text-center text-xs font-bold py-2 px-4 rounded-lg text-white ${s.sectionColor} opacity-90 hover:opacity-100 transition-opacity`} data-id="element-505">
                      Quiero Este Protocolo →
                    </a>
                  </div>
                </div>}
            </motion.div>)}
        </div>

        <div className="mt-8 bg-[#2D5A3D] text-white rounded-xl p-6 text-center" data-id="element-506">
          <p className="font-serif font-bold text-xl mb-2" data-id="element-507">
            Los 9 Protocolos. Un Solo Manual.
          </p>
          <p className="text-[#F0F4EC]/80 text-sm mb-4" data-id="element-508">
            Cada uno con dosis exactas, preparación paso a paso y respaldo
            científico real.
          </p>
          <a href="#comprar" className="inline-block bg-[#C17817] text-white font-bold py-3 px-8 rounded-lg text-sm uppercase tracking-wide hover:bg-[#A66510] transition-colors shadow-lg" data-id="element-509">
            Obtener Acceso Completo por $6.97 →
          </a>
        </div>
      </div>
    </section>;
}